<template>
  <!--工位工时损耗-->
  <dv-border-box-13>
    <div class="item" :style="{ height: col + 'vh' }">
      <div class="font-weight font-s">{{ title }}</div>
      <div id="stationLossEchart"></div>
      <canvas id="myCanvas" width="300" height="150" style="display: none">
        Your browser does not support the HTML5 canvas tag.
      </canvas>
    </div>
  </dv-border-box-13>


</template>

<script>
export default {
  name: "andon-station-loss",
  props: {
    col: {
      type: Number,
      default: function () {
        return 28;
      },
    },
    hours: {
      type: Array,
      default: function () {
        return [];
      },
    },
    headTitle: {
      type: String,
      default: function () {
        return "工位工时损耗";
      },
    },
  },
  data() {
    return {
      title: this.headTitle,
      bean: this.deviceBean,
      hourBean: this.hours,
      types: this.typeBean,
      startCharts: undefined,
      items: [],
      cookie: null,
    };
  },
  watch: {
    hours: {
      handler: function (val, oldVal) {
        this.hourBean = val;
        this.lineEchart();
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    lineEchart() {
      var lineEchart = this.$echarts.init(
        document.getElementById("stationLossEchart")
      );
      var data = this.hourBean;
      var xdata = [];
      var lineData = [];
      var lineData2 = [];
      var yMax1 = data[0].count;
      var yMax2 = data[0].hour;
      data.forEach((re) => {
        if (re.count > yMax1) {
          yMax1 = re.count;
        }
        if (re.hour > yMax2) {
          yMax2 = re.hour;
        }
        xdata.push(re.title);
        lineData.push(re.count);
        var hour = (Number(re.hour) / (1000 * 60)).toFixed(2);
        lineData2.push(hour);
      });

      //自适应开始--------------------------------------
      var fontSize = 12;
      var symbolOffset = 12;
      var margin = 8;
      var yName = '损耗工时';
      var yNameGap = symbolOffset;
      var c=document.getElementById("myCanvas");
      var ctx=c.getContext("2d");
      ctx.font="12px none";
      var gridTop = symbolOffset + fontSize + 2;
      if(yName == null){
        gridTop = symbolOffset;
      }
      var gridLeft = 0;
      var gridBottom = fontSize + margin + 2;
      var gridRight = 0;
      var rotate = 0;

      var yLable1 = "";

      if(yMax1.toString().indexOf('.') != -1){
        yLable1 = yMax1.toString() + "0";
      }else{
        yLable1 = yMax1.toString() + ".0";
      }
      var yLable2 = ((yMax2/ (1000 * 60)).toFixed(2)).toString();
      if(yLable2.indexOf('.') != -1){
        yLable2 = yLable2 + "0";
      }else{
        yLable2 = yLable2 + ".0";
      }
      yLable2 = yLable2 + " m";
      gridLeft = ctx.measureText(yLable2).width + margin;
      gridRight = ctx.measureText(yLable1).width + margin;
      var gridWidth = (lineEchart.getWidth() - gridRight - gridLeft) / xdata.length;
      var lastWidth = 0;
      var xdataIndex = 0;
      var maxWidth = 0;
      xdata.forEach((text) => {
        var thisWidth = ctx.measureText(text).width;

        if(thisWidth > maxWidth){
          maxWidth = thisWidth;
        }
        if(lastWidth == 0){
          //第一个
          if((thisWidth / 2) > gridLeft){
            rotate = 45;
          }
        }

        if((thisWidth / 2 + lastWidth / 2) > gridWidth){
            rotate = 45;
        }

        if(xdataIndex == (xdata.length - 1)){
          //最后一个
          if((thisWidth / 2) > gridRight){
            rotate = 45;
          }
        }
        lastWidth = thisWidth;
        xdataIndex++;
      });

      if(rotate == 45){
        gridBottom = Math.sqrt(maxWidth * maxWidth / 2) + margin + fontSize / 2;
        if(gridBottom > lineEchart.getHeight() /  3 * 1){
          gridBottom = lineEchart.getHeight() /  3 * 1;
        }
      }
      //自适应结束--------------------------------------
      var option = {
        grid: {
          top: gridTop,
          left: gridLeft,
          right: gridRight,
          bottom: gridBottom,
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["损耗工时", "异常个数"],
          textStyle: {
            color: "#ffffff",
          },
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          nameTextStyle: {
            color: "#ffffff",
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#fff",
              fontSize: fontSize,
            },
            interval: 0,
            rotate: rotate,
          },
          data: xdata,
        },
        yAxis: [
          {
            type: "value",
            name: "损耗工时",
            nameGap: yNameGap,
            nameTextStyle:{
              color: "#fff",
              fontSize: fontSize,
              verticalAlign: 'bottom',
            },
            min: 0,
            max: (Number(yMax2) / (1000 * 60)).toFixed(2),
            splitNumber: 4,
            axisLabel: {
              formatter: "{value} m",
              margin: margin,
              textStyle: {
                color: "#fff",
                fontSize: fontSize,
              },
            },
            axisLine: {
              show: true,
              symbol: ["none", "arrow"],
              symbolOffset: symbolOffset,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            type: "value",
            name: "异常个数",
            nameGap: yNameGap,
            nameTextStyle:{
              color: "#fff",
              fontSize: fontSize,
              verticalAlign: 'bottom',
            },
            min: 0,
            max: yMax1,
            splitNumber: 4,
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              show: true,
              symbol: ["none", "arrow"],
              symbolOffset: symbolOffset,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "异常个数",
            type: "line",
            yAxisIndex: 1,
            data: lineData,
          },
          {
            name: "损耗工时",
            type: "line",
            data: lineData2,
            itemStyle: {
              normal: {
                color: "#05D1FC", //折现点颜色
                lineStyle: {
                  color: "#05D1FC", //折现颜色
                },
              },
            },
          },
        ],
      };

      lineEchart.setOption(option);

      console.log(lineEchart.getOption());
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

      if (this.cookie) {
        clearInterval(this.cookie);
      }

      var index = 0; //显示tooltip,播放所在下标
      this.cookie = setInterval(function () {
        lineEchart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= xdata.length) {
          index = 0;
        }
      }, 2000);
    },
  },
};
</script>


<style scoped>
.item {
  padding: 0.33rem 0.2rem 0.2rem;
  display: flex; flex-direction: column;
}
.item > div:nth-child(2){
  flex: auto;
  width: 100%;
  padding: 6px;
}

/*左边中间部分排行榜*/
.biaoge_pai {
  overflow: hidden;
}
.biaoge_pai ul li {
  height: 20%;
}
.biaoge_pai ul li .liIn {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  color: #fff;
  font-size: 0.06rem;
  height: 0.6rem;
}
.biaoge_pai ul li .liIn .liIn_left {
  width: 25%;
  position: relative;
  padding-left: 0.3rem;
}
.biaoge_pai ul li .liIn .liIn_left .bot {
  width: 0.2rem;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 1000px;
  display: block;
  position: absolute;
  left: 0.02rem;
  top: 0;
  bottom: 0;
  margin: auto 0;
}
.biaoge_pai ul li .liIn2 .liIn_left .bot {
  background: #e7feb8;
}
.biaoge_pai ul li .liIn3 .liIn_left .bot {
  background: #fdea8a;
}
.biaoge_pai ul li .liIn4 .liIn_left .bot {
  background: #8ff9f8;
}
.biaoge_pai ul li .liIn5 .liIn_left .bot {
  background: #91cc75;
}
.biaoge_pai ul li .liIn6 .liIn_left .bot {
  background: #05d1fc;
}

.biaoge_pai ul li .liIn .liIn_line {
  width: 58%;
  height: 0.2rem;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 2000px;
}
.biaoge_pai ul li .liIn .liIn_line .line_lineIn {
  width: 100%;
  height: 0.2rem;
  background: #91cc75;
  border-radius: 100px;
  -webkit-animation: widthMove1 2s ease-in-out;
}
.biaoge_pai ul li .liIn2 .liIn_line .line_lineIn {
  background: #e7feb8;
  -webkit-animation: widthMove2 2s ease-in-out;
}
.biaoge_pai ul li .liIn3 .liIn_line .line_lineIn {
  background: #fdea8a;
  -webkit-animation: widthMove3 2s ease-in-out;
}
.biaoge_pai ul li .liIn4 .liIn_line .line_lineIn {
  background: #8ff9f8;
  -webkit-animation: widthMove4 2s ease-in-out;
}
.biaoge_pai ul li .liIn5 .liIn_line .line_lineIn {
  background: #d890fa;
  -webkit-animation: widthMove5 2s ease-in-out;
}
.biaoge_pai ul li .liIn6 .liIn_line .line_lineIn {
  background: #05d1fc;
  -webkit-animation: widthMove6 2s ease-in-out;
}
@-webkit-keyframes widthMove1 {
  0% {
    width: 0%;
  }
  100% {
    width: 98.5%;
  }
}
@-webkit-keyframes widthMove2 {
  0% {
    width: 0%;
  }
  100% {
    width: 88.5%;
  }
}
@-webkit-keyframes widthMove3 {
  0% {
    width: 0%;
  }
  100% {
    width: 68.5%;
  }
}
@-webkit-keyframes widthMove4 {
  0% {
    width: 0%;
  }
  100% {
    width: 40.5%;
  }
}
@-webkit-keyframes widthMove5 {
  0% {
    width: 0%;
  }
  100% {
    width: 22.5%;
  }
}
@-webkit-keyframes widthMove6 {
  0% {
    width: 0%;
  }
  100% {
    width: 10.5%;
  }
}

.biaoge_pai ul li .liIn .num {
  font-family: dig;
  padding-left: 0.1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/andon/component/station-loss.vue